import catchAsync from "../../utils/catchAsync";
import httpsCall from "../httpsCall";

export const faqApi = catchAsync(async () => {  
    const data = await httpsCall.get(`faq/faq-list/1/20`);
    return data;
});